import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

import { Dashboard, LoadingScreen } from '@/components'
import { accountSelector } from '@/store/accountSlice'
import { isValid } from '@/utils'

const Auth = () => {
  const { user, token, loading } = useSelector(accountSelector)

  if (loading || (token && isValid(token) && !user)) return <LoadingScreen />

  if (!user && !loading) return <Navigate to="/login" />

  return <Dashboard />
}

export default Auth
